module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Jaris Ash has held various office-based jobs in the past, but she has always had a passion for writing and a love for dogs. Eventually, she decided to combine her two interests, writing from a dog’s perspective for her local training club newsletter, and creating a series of stories for use in Animal Assisted Therapy sessions. All of the characters in her stories are inspired by her real-life dogs, who have made the recent years extremely interesting, even though they have driven her a bit bonkers at times. With trips round Europe – all the way across to Tunnel Harry in Poland on one occasion – as well as agility Have-A-Go events at local schools, fairs and fetes, it’s safe to say that things are never dull in her household.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0235a5e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0